import config from "../../config";
import React, { useEffect, useState, useMemo, Fragment } from "react";
import styled from "styled-components";
import { IconButton } from "@mui/material";
import DriverStandings from "../DriverStandings";
import theme from "../../styles/theme";
import { sideFadeMask } from "../../styles/variables";
import {
  getDivisionColor,
  getDivisionTextColor,
  getDivisionPriority,
} from "../../utils/helpers/divisionUtils";

import { TitleContainer } from "./LastRaceResults";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useStandingsContext } from "../../contexts/standings";

import PodiumDrivers from "./PodiumDrivers";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { TitleTopContainer } from "./LastRaceResults";
import { useScheduleContext } from "../../contexts/schedule";

import ChampionSeason1ImagePhone from "../../assets/PodiumBackground/Drivers/championSeason1Phone.png";
import ChampionSeason2ImagePhone from "../../assets/PodiumBackground/Drivers/championSeason2Phone.png";
import ChampionSeason3ImagePhone from "../../assets/PodiumBackground/Drivers/championSeason3Phone.png";
import ChampionSeason4ImagePhone from "../../assets/PodiumBackground/Drivers/championSeason4Phone.png";
import ChampionSeason5ImagePhone from "../../assets/PodiumBackground/Drivers/championSeason5Phone.png";
import ChampionSeason6ImagePhone from "../../assets/PodiumBackground/Drivers/championSeason6Phone.png";
import ChampionSeason7ImagePhone from "../../assets/PodiumBackground/Drivers/championSeason7Phone.png";
import ChampionSeasonNonePhone from "../../assets/PodiumBackground/Drivers/championSeasonNonePhone.png";

import ChampionSeason1Image from "../../assets/PodiumBackground/Drivers/championSeason1.png";
import ChampionSeason2Image from "../../assets/PodiumBackground/Drivers/championSeason2.png";
import ChampionSeason3Image from "../../assets/PodiumBackground/Drivers/championSeason3.png";
import ChampionSeason4Image from "../../assets/PodiumBackground/Drivers/championSeason4.png";
import ChampionSeason5Image from "../../assets/PodiumBackground/Drivers/championSeason5.png";
import ChampionSeason6Image from "../../assets/PodiumBackground/Drivers/championSeason6.png";
import ChampionSeason7Image from "../../assets/PodiumBackground/Drivers/championSeason7.png";
import ChampionSeasonNone from "../../assets/PodiumBackground/Drivers/championSeasonNone.png";

export const SwitcherContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
  margin-top: 24px;
  margin-bottom: 16px;
`;

export const SwitcherBadge = styled.button`
  background-color: ${(props) =>
    props.$active
      ? props.$color || "transparent"
      : props.$darkBackground
        ? "rgba(0, 0, 0, 0.6)"
        : "rgba(255, 255, 255, 0.05)"};
  color: ${(props) =>
    props.$active
      ? props.$color
        ? getDivisionTextColor(props.$color)
        : theme.colors.white
      : props.$darkBackground
        ? "rgba(255, 255, 255, 0.8)"
        : theme.colors.grey};
  border: 1px solid
    ${(props) =>
      props.$active
        ? "transparent"
        : props.$darkBackground
          ? "rgba(255, 255, 255, 0.3)"
          : "rgba(255, 255, 255, 0.1)"};
  padding: 4px 12px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 4px;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-family: "Roboto Condensed", sans-serif;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: ${(props) =>
      props.$active
        ? props.$color || "transparent"
        : props.$darkBackground
          ? "rgba(0, 0, 0, 0.8)"
          : "rgba(255, 255, 255, 0.15)"};
    border-color: ${(props) =>
      props.$active
        ? "transparent"
        : props.$darkBackground
          ? "rgba(255, 255, 255, 0.5)"
          : "rgba(255, 255, 255, 0.1)"};
  }
`;

const ChangeSeasonBtnContainer = styled.div`
  z-index: 1;
  display: flex;
  justify-content: center;
  gap: 10px;
`;

const StyledIconPrev = styled.i`
  &.swiper-button-disabled {
    background-color: transparent;
    opacity: 0;
    pointer-events: none;
    cursor: default;
  }
`;

const StyledIconNext = styled.i`
  &.swiper-button-disabled {
    background-color: transparent;
    opacity: 0;
    pointer-events: none;
    cursor: default;
  }
`;
const Background = styled.div`
  position: absolute;
  width: 100vw;
  margin-left: calc(50% - 50vw);
  left: 0px;
  height: 300px;
  // background: linear-gradient(
  //   90deg,
  //   ${theme.colors.darkLight} 0%,
  //   ${theme.colors.darkLight} 45%,
  //   ${theme.colors.darkLight} 55%,
  //   ${theme.colors.darkLight} 100%
  // );
`;

const StyledImg = styled.img`
  position: absolute;
  width: 100vw;
  margin-left: calc(50% - 50vw);
  left: 0px;
  height: 300px;
  object-fit: cover;
  opacity: 0.5;
  mask-image: ${sideFadeMask};
  -webkit-mask-image: ${sideFadeMask};
`;

const StyledSwiperSlide = styled(SwiperSlide)`
  height: 300px;
`;

const StyledTitleContainer = styled(TitleContainer)`
  max-width: 800px;
  width: auto;
`;

const BackgroundPodiumDriver = ({ currentSeasonId, setCurrentSeasonId }) => {
  const { loadSeason: loadSeasonStandings, standings } = useStandingsContext();
  const { seasons, loadSchedule } = useScheduleContext({});
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [selectedDivision, setSelectedDivision] = useState(null);
  const [swiper, setSwiper] = useState(null);

  const currentSeason = seasons[currentSeasonId];
  const divisionColors = currentSeason?.divisionColors;
  const driversMap = standings[currentSeasonId]?.drivers;

  const resolvedDivisions = useMemo(() => {
    if (currentSeason?.childSeasons && currentSeason.childSeasons.length > 0) {
      const list = [];
      currentSeason.childSeasons.forEach((child) => {
        // Prefer fully-loaded season for name/colors, fallback to embedded child data
        const childSeason = seasons[child.id] || child;
        const childDivColors =
          childSeason.divisionColors || child.divisionColors || divisionColors || {};
        const childDriversMap = standings[child.id]?.drivers;
        if (childDriversMap) {
          const keys = Array.isArray(childDriversMap) ? [] : Object.keys(childDriversMap);
          keys.forEach((div) => {
            const label = div === config.defaultDivision ? childSeason.shortName : div;
            list.push({
              key: `${child.id}_${div}`,
              label: label,
              divisionName: div,
              seasonId: child.id,
              colorKey: div,
              divisionColors: childDivColors,
            });
          });
        }
      });
      return list.sort((a, b) => {
        const indexA = currentSeason.childSeasons.findIndex((c) => c.id === a.seasonId);
        const indexB = currentSeason.childSeasons.findIndex((c) => c.id === b.seasonId);
        if (indexA !== indexB) {
          return indexA - indexB;
        }
        return (
          getDivisionPriority(a.divisionColors, a.colorKey) -
          getDivisionPriority(b.divisionColors, b.colorKey)
        );
      });
    }

    if (!driversMap) return [];
    const keys = Array.isArray(driversMap) ? [] : Object.keys(driversMap);
    return keys
      .map((div) => ({
        key: div,
        label: div,
        divisionName: div,
        seasonId: currentSeasonId,
        colorKey: div,
        divisionColors: divisionColors,
      }))
      .sort(
        (a, b) =>
          getDivisionPriority(divisionColors, a.key) - getDivisionPriority(divisionColors, b.key),
      );
  }, [currentSeason, standings, driversMap, divisionColors, currentSeasonId, seasons]);

  const activeDivisionObj = useMemo(() => {
    return resolvedDivisions.find((d) => d.key === selectedDivision) || resolvedDivisions[0];
  }, [resolvedDivisions, selectedDivision]);

  useEffect(() => {
    if (resolvedDivisions.length > 0) {
      const keys = resolvedDivisions.map((d) => d.key);
      if (!selectedDivision || !keys.includes(selectedDivision)) {
        setSelectedDivision(resolvedDivisions[0].key);
      }
    } else {
      setSelectedDivision(null);
    }
  }, [resolvedDivisions, selectedDivision]);

  const podiumDrivers = useMemo(() => {
    if (!activeDivisionObj) return undefined;
    const activeStandings = standings[activeDivisionObj.seasonId]?.drivers;
    if (!activeStandings) return undefined;
    if (Array.isArray(activeStandings)) return activeStandings;
    return activeStandings[activeDivisionObj.divisionName] || [];
  }, [standings, activeDivisionObj]);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getImage = (season) => {
    switch (season) {
      case 1:
        return windowWidth < 768 ? ChampionSeason1ImagePhone : ChampionSeason1Image;
      case 2:
        return windowWidth < 768 ? ChampionSeason2ImagePhone : ChampionSeason2Image;
      case 3:
        return windowWidth < 768 ? ChampionSeason3ImagePhone : ChampionSeason3Image;
      case 4:
        return windowWidth < 768 ? ChampionSeason4ImagePhone : ChampionSeason4Image;
      case 5:
        return windowWidth < 768 ? ChampionSeason5ImagePhone : ChampionSeason5Image;
      case 6:
        return windowWidth < 768 ? ChampionSeason6ImagePhone : ChampionSeason6Image;
      case 7:
        return windowWidth < 768 ? ChampionSeason7ImagePhone : ChampionSeason7Image;
      case 8:
        return windowWidth < 768 ? ChampionSeasonNonePhone : ChampionSeasonNone;
      default:
        return windowWidth < 768 ? ChampionSeasonNonePhone : ChampionSeasonNone;
    }
  };

  const seasonsList = useMemo(() => {
    return Object.values(seasons)
      .filter((s) => s.simulator && !s.parentSeasonId)
      .sort((a, b) => new Date(b.endDate) - new Date(a.endDate))
      .map((s) => s.id);
  }, [seasons]);

  // Extract prev/next season IDs from HATEOAS links
  const prevSeasonId = useMemo(() => {
    const href = currentSeason?._links?.prev?.href;
    if (!href) return null;
    const m = href.match(/\/seasons\/(\d+)/);
    return m ? Number(m[1]) : null;
  }, [currentSeason]);

  const nextSeasonId = useMemo(() => {
    const href = currentSeason?._links?.next?.href;
    if (!href) return null;
    const m = href.match(/\/seasons\/(\d+)/);
    return m ? Number(m[1]) : null;
  }, [currentSeason]);

  const handleSeasonChangeLeft = () => {
    if (prevSeasonId) setCurrentSeasonId(prevSeasonId);
  };

  const handleSeasonChangeRight = () => {
    if (nextSeasonId) setCurrentSeasonId(nextSeasonId);
  };

  useEffect(() => {
    loadSchedule(currentSeasonId, true);
    loadSeasonStandings(currentSeasonId);
  }, [currentSeasonId]); // eslint-disable-line

  useEffect(() => {
    if (!swiper) return;
    const index = seasonsList.indexOf(currentSeasonId);
    if (index >= 0) {
      swiper.slideTo(index);
    }
  }, [swiper, currentSeasonId, seasonsList]);

  return (
    <>
      <PodiumDrivers
        drivers={podiumDrivers}
        seasonId={activeDivisionObj ? activeDivisionObj.seasonId : currentSeasonId}
      >
        <TitleTopContainer>Особистий залік</TitleTopContainer>
        <Fragment>
          <Background>
            <Swiper
              modules={[Pagination]}
              style={{ width: "100%" }}
              watchSlidesProgress={false}
              slidesPerView={"auto"}
              spaceBetween={0}
              className="mySwiper"
              speed={500}
              onSwiper={setSwiper}
              initialSlide={Math.max(0, seasonsList.indexOf(currentSeasonId))}
              noSwiping={true}
              noSwipingSelector=".swiper-slide"
            >
              {seasonsList.map((season) => (
                <StyledSwiperSlide key={season}>
                  <StyledImg src={getImage(season)} />
                </StyledSwiperSlide>
              ))}
            </Swiper>
          </Background>
        </Fragment>
        <ChangeSeasonBtnContainer>
          {prevSeasonId ? (
            <StyledIconPrev onClick={handleSeasonChangeLeft}>
              <IconButton>
                <KeyboardArrowLeftIcon sx={{ fontSize: "60px", color: `${theme.colors.green}` }} />
              </IconButton>
            </StyledIconPrev>
          ) : (
            <div style={{ width: 62 }} />
          )}
          <StyledTitleContainer>{seasons[currentSeasonId]?.shortName}</StyledTitleContainer>
          {nextSeasonId ? (
            <StyledIconNext onClick={handleSeasonChangeRight}>
              <IconButton>
                <KeyboardArrowRightIcon sx={{ fontSize: "60px", color: `${theme.colors.green}` }} />
              </IconButton>
            </StyledIconNext>
          ) : (
            <div style={{ width: 62 }} />
          )}
        </ChangeSeasonBtnContainer>
      </PodiumDrivers>
      {resolvedDivisions.length > 1 && (
        <SwitcherContainer>
          {resolvedDivisions.map((division) => {
            const divisionColor = getDivisionColor(division.divisionColors, division.colorKey);
            const active = selectedDivision === division.key;
            return (
              <SwitcherBadge
                key={division.key}
                $active={active}
                $color={divisionColor}
                onClick={() => setSelectedDivision(division.key)}
              >
                {division.label}
              </SwitcherBadge>
            );
          })}
        </SwitcherContainer>
      )}
      <div style={{ marginTop: 12 }}>
        <DriverStandings
          seasonId={activeDivisionObj ? activeDivisionObj.seasonId : currentSeasonId}
          selectedDivision={activeDivisionObj ? activeDivisionObj.divisionName : null}
        />
      </div>
    </>
  );
};

export default BackgroundPodiumDriver;
